module.exports = __webpack_public_path__ + "img/inscricoes-abertas.svg";